import React from 'react';

import { FormField, IFormInput } from 'common/components/form/Wrapper';

type ITextField = Omit<IFormInput, 'type' | 'icon' | 'max' | 'min' | 'step'>;

export const TextField = ({
  name,
  type,
  disableAutoComplete,
  placeholder,
  placeholderColor,
  margin,
  padding,
  ...rest
}: ITextField) => {
  return (
    <FormField
      {...rest}
      padding={padding}
      placeholder={placeholder}
      placeholderColor={placeholderColor}
      name={name}
      type={type || 'text'}
      data-lpignore="true"
      autocomplete={disableAutoComplete || 'on'}
      extendedStyles={rest.extendedStyles}
      margin={margin}
    />
  );
};
